import React, { useState, useEffect } from "react"
import CallTableViewModel from "../../../ViewModels/CallTableViewModel"
import CustomerFiltersViewModel from "./ViewModels/CustomerFilterViewModel"
import { InputType } from "../Enums/InputType"
import { InputProps } from "../Interfaces/InputProps";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import { TextFieldValidator } from "../Utility/InputValidation";
import { useSnackbar } from "notistack";

interface IFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function CustomerFilterDialog(props: IFiltersDialogProps) {
    const [customerFilter, setCustomerFilter] = useState<CustomerFiltersViewModel>(props.callTableViewModel.filters.customerFilters);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (props.open) {
            setCustomerFilter(props.callTableViewModel.filters.customerFilters);
        }
    }, [props.open])


    const Confirm = () => {
        //ensure the phone number is empty or valid before continuing
        if (
            customerFilter.telephone.length === 0
            || (customerFilter.telephone.length >= 11 && customerFilter.telephone.length <= 12)) {
            const newCallTableViewModel = { ...props.callTableViewModel };

            newCallTableViewModel.filters.customerFilters = customerFilter;

            props.setCallTableViewModel({
                ...newCallTableViewModel
            })

            props.setOpen(false);
        } else {
            enqueueSnackbar("Invalid phone number, either provide a valid number or remove this value", { variant: 'warning' });

        }
    }

    const handleChange = (e: any) => {
        if (TextFieldValidator(e.target.value))
            setCustomerFilter({
                ...customerFilter,
                [e.target.name]: e.target.value
            })
    }

    const handlePhoneNumberChange = (e: any) => {
        if (!isNaN(e.target.value) && e.target.value.length <= 12)
            setCustomerFilter({
                ...customerFilter,
                telephone: e.target.value
            })
    }

    const inputProps: InputProps[] = [
        {
            name: 'customerID',
            label: 'Customer ID',
            value: customerFilter.customerID,
            type: InputType.TextField
        },
        {
            name: 'clientRef',
            label: 'Client Reference',
            value: customerFilter.clientRef,
            type: InputType.TextField
        },
        {
            name: 'urn',
            label: 'URN',
            value: customerFilter.urn,
            type: InputType.TextField
        },
    ];

    const getInput = (inputProps: InputProps) => {
        return (
            <Grid key={inputProps.name} size={12}>
                <InputLabel>{inputProps.label}</InputLabel>
                {
                    inputProps.type === InputType.TextField &&
                    <TextField
                        name={inputProps.name}
                        onChange={handleChange}
                        value={inputProps.value}
                        fullWidth
                    />
                }
            </Grid>)
    }

    return (
        <Dialog
            open={props.open} onClose={() => props.setOpen(false)} fullWidth maxWidth="sm">
            <DialogTitle>
                Customer Information
            </DialogTitle>
            <DialogContent>
                <Grid container justifyContent={"center"} alignItems={"center"} spacing={2} style={{ width: '100%', marginTop: '8px' }}>
                    {
                        inputProps.map(props => getInput(props))
                    }
                    <Grid key='telephone' size={12}>
                        <InputLabel>Customer Phone Number</InputLabel>
                        {
                            <TextField
                                name='telephone'
                                onChange={handlePhoneNumberChange}
                                value={customerFilter.telephone}
                                type="number"
                                fullWidth
                            />
                        }
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.setOpen(false)} color="primary">Cancel</Button>
                <Button onClick={Confirm} color="primary">Confirm</Button>
            </DialogActions>
        </Dialog>
    )
}